<template>
  <div style="min-width: 250px;">
    <v-text-field
      placeholder="Comment"
      :value="value"
      @input="(inputValue) => $emit('input', inputValue)"
      auto-grow
      rows="1"
      hide-details
      clearable
      :readonly="!$store.state.auth.checkAccess({key: 'payment_handler_update', value: true})"
      :append-icon="saveIcon && $store.state.auth.checkAccess({key: 'payment_handler_update', value: true}) ? 'mdi-content-save' : ''"
      @click:append="$emit('updateTransaction')"
      class="payment-handler-update-comment pa-0 ma-0"
    >
      <template #prepend-inner>
        <v-menu offset-y max-height="400" v-if="commentsPreset.length > 0">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              small
              v-bind="attrs"
              v-on="on"
              class="px-0"
              style="float: left; min-width: 20px; margin-right: 3px"
            >
              <v-icon>keyboard_arrow_down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(comment, index) in commentsPreset"
              :key="comment + index"
              @click="$emit('input', comment)"
            >
              <v-list-item-title>{{ comment }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-text-field>
  </div>
</template>

<script>
  export default {
    name: 'WithdrawComments',
    props: {
      value: {
        type: String,
        default: ''
      },
      commentsPreset: {
        type: Array,
        default: () => ([
          'Complete',
          'For verification',
          'Withdrawal —— (verify)',
          'Waiting for docs !!!',
          'Split withdraw',
          'Combine withdrawals',
          'Sport checking',
          'Unwagered deposit',
          'Extra winning from No deposit Bonus',
          'Incorrect payment method',
          'Cancel: Verification failed',
        ])
      },
      saveIcon: {
        type: Boolean,
        default: true
      }
    },
    emits: [ 'updateTransaction', 'input' ],
    data () {
      return {}
    }
  }
</script>

<style scoped>
  ::v-deep.payment-handler-update-comment input {
    font-size: 14px;
    line-height: 1.35em;
  }
</style>
